module.exports = __webpack_public_path__ + "img/PreIntermediateGroups.00541b70.webp";